<template>
  <WdsText size="sm" color="gray-500">
    {{ displayDate }}
  </WdsText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import useDate from '@/composables/useDate'

const PaymentRequestBillingEndDateColumn = graphql(`
  fragment PaymentRequestBillingEndDateColumn on PaymentRequest {
    id
    endDate
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestBillingEndDateColumn>
}>()

const column = computed(() => useFragment(PaymentRequestBillingEndDateColumn, props.row))

const formattedDate = useDate(
  computed(() => column.value.endDate),
  'MMM D, YYYY',
)

const displayDate = computed(() =>
  formattedDate.isValid.value ? formattedDate.date.value : '-',
)
</script>

